var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable no-nested-ternary */
import React, { useState, useContext } from 'react';
import { useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import MenuOutlined from '@material-ui/icons/MenuOutlined';
import Button from '@material-ui/core/Button';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import ListItemText from '@material-ui/core/ListItemText';
import { useTranslation } from 'react-i18next';
import { Avatar, Fade, ListItemIcon, } from '@material-ui/core';
import { usePhoneView } from '@michelin/acid-components';
import MenuItem from '@material-ui/core/MenuItem';
import { CentralProviderContext } from '../../centralProviderContext/CentralProviderContext';
import { navigateToMichelin } from '../../helpers/navigateToMichelin';
import { getAppIconByName } from '../../helpers/getAppIconByName';
import { NavigateDataType } from '../../types/NavigateData';
import { StyledMenu } from '../../styles/appsMenuStyle';
import { useStyles } from '../../styles/sideAppsMenuStyle';
import { AuthContext } from '../../authContext/AuthContext';
var getIcon = function (e) { return getAppIconByName(e.name); };
export var AppsMenu = function (_a) {
    var _b, _c;
    var small = _a.small, onClickWhenSmall = _a.onClickWhenSmall;
    var _d = __read(useState(null), 2), anchorEl = _d[0], setAnchorEl = _d[1];
    var centralProviderContext = useContext(CentralProviderContext);
    var authResult = useContext(AuthContext).authResult;
    var t = useTranslation().t;
    var theme = useTheme();
    var phoneView = usePhoneView('xs');
    var tabletView = usePhoneView('sm');
    var classes = useStyles({});
    var handleLink = React.useCallback(function (data) {
        var _a;
        navigateToMichelin(data.url, {
            auth: true,
            type: NavigateDataType.NAVIGATE,
            authInfo: authResult,
            profile: (_a = centralProviderContext.centralProfile) === null || _a === void 0 ? void 0 : _a.auth0,
            data: centralProviderContext,
        }, '_top');
    }, [centralProviderContext]);
    if (!centralProviderContext.centralProfile)
        return null;
    var selectedApp = centralProviderContext
        .centralProfile.applications.find(function (a) { return a.app_key === centralProviderContext.application; });
    var apps = centralProviderContext.centralProfile
        ? centralProviderContext.centralProfile.applications
            .sort(function (a, b) { return a.name.toLowerCase().localeCompare(b.name.toLowerCase()); })
            .filter(function (a) { return (selectedApp ? a.url !== selectedApp.url : true); })
        : [];
    var onClickHandler = function (e) {
        if (onClickWhenSmall && small) {
            onClickWhenSmall();
        }
        setAnchorEl(e.currentTarget);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { "aria-label": "menu", className: clsx(classes.selector, (_b = {},
                _b["".concat(classes.selector, "--open")] = !!anchorEl,
                _b["".concat(classes.selector, "--small")] = small,
                _b)), onClick: onClickHandler, disabled: !apps.length, disableRipple: true }, selectedApp ? (React.createElement(React.Fragment, null,
            React.createElement(Avatar, { className: clsx(classes.avatar, (_c = {},
                    _c["".concat(classes.avatar, "--small")] = small,
                    _c)), style: { boxShadow: '0px 2px 4px rgb(0 0 0 / 30%)', backgroundColor: theme.palette.background.paper } },
                React.createElement(ListItemIcon, { className: clsx(classes.listItem, "".concat(classes.listItem, "--selected")) }, getIcon(selectedApp))),
            React.createElement(React.Fragment, null,
                React.createElement(ListItemText, { primary: t(selectedApp.name), style: { opacity: !small ? 1 : 0 }, primaryTypographyProps: {
                        style: {
                            fontSize: '.8rem',
                            textTransform: 'capitalize',
                            fontWeight: 'bold',
                            marginLeft: '5px',
                            textAlign: 'initial',
                            maxHeight: '37px',
                            overflow: 'hidden',
                        },
                    }, className: classes.selectorLabel }),
                React.createElement(ListItemIcon, { color: "primary", className: classes.listItem, style: { opacity: !small ? 1 : 0 } },
                    React.createElement(React.Fragment, null,
                        React.createElement(KeyboardArrowUp, { className: classes.listItemIcon, style: { top: '2px' } }),
                        React.createElement(KeyboardArrowDown, { className: classes.listItemIcon, style: { bottom: '2px' } })))))) : (React.createElement(MenuOutlined, { fontSize: "inherit" }))),
        React.createElement(StyledMenu, { id: "customized-menu", anchorEl: anchorEl, keepMounted: true, open: !!anchorEl, onClose: function () { return setAnchorEl(null); }, getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, TransitionComponent: Fade, autoFocus: false, MenuListProps: {
                style: {
                    padding: '0',
                },
            }, PaperProps: {
                style: {
                    maxHeight: '300px',
                    width: tabletView ? (phoneView ? 'calc(75% - 32px)' : 'calc(45% - 32px)') : '288px',
                    borderRadius: '8px',
                    transformOrigin: '0px 0px',
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                    borderTop: 'none',
                },
            } }, apps.map(function (e) { return (React.createElement(MenuItem, { style: { alignItems: 'center', padding: '8px 8px' }, onClick: function () { return handleLink(e); }, key: e.app_key },
            React.createElement(Avatar, { style: { backgroundColor: 'transparent', height: '32px', width: '32px' } },
                React.createElement(ListItemIcon, { color: "primary", className: classes.listItem }, getIcon(e))),
            React.createElement(ListItemText, { primaryTypographyProps: {
                    style: {
                        fontSize: '.8rem',
                        textTransform: 'capitalize',
                        marginLeft: '10px',
                        textAlign: 'justify',
                        whiteSpace: 'normal',
                        overflow: 'hidden',
                    },
                }, primary: t(e.name) }))); }))));
};
//# sourceMappingURL=AppsMenu.js.map